import React from 'react';
import { MailIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-grape/15 bg-white/70" data-id="element-67" data-mp="3gfsp4jdu96q5">
      <div className="mx-auto max-w-4xl px-5 py-12 text-center" data-id="element-68" data-mp="3gh3q6bfwg0dk">
        <p className="font-display text-xl font-black text-plum" data-id="element-69" data-mp="32p5kybpb6omo">
          K-VISUAL MASTERPLAN<span className="align-super text-xs" data-id="element-70" data-mp="36qhf8uj4ny17">™</span>
        </p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-plum/65" data-id="element-71" data-mp="3ufa4y995p9nd">
          Die visuelle Methode, um Koreanisch von null an zu lernen: Hangeul, Aussprache, echte
          Sätze und K-Drama- / K-Pop-Ausdrücke in 60 Minuten. Denn die koreanische Kultur zu lieben
          sollte nicht bedeuten, für immer von Untertiteln abhängig zu sein.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-plum/75" data-id="element-72" data-mp="3qfjj8jyhljpp">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-73" data-mp="2a1jjb8zn5u2g">
            <MailIcon className="h-4 w-4 text-grape" data-id="element-74" data-mp="3lbmvrwv0jgi0" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-grape" data-id="element-75" data-mp="3gck1n7gkmuot">
            <InstagramIcon className="h-4 w-4 text-grape" data-id="element-76" data-mp="3q8wrtvcwqqet" /> @sigmasmart.deutshc
          </a>
        </div>

        <p className="mt-4 font-display text-base font-semibold italic text-grape" data-id="element-77" data-mp="82ienymgqkhh">
          🌸 « 안녕하세요 — Dein erstes koreanisches Wort beginnt heute. »
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-plum/45" data-id="element-78" data-mp="31umh9mhzxlo">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-79" data-mp="huwlv6wb8jb1">
            Nutzungsbedingungen
          </a>
          <span data-id="element-80" data-mp="qt05fxnqj607">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-81" data-mp="qub8fv9cw9q9">
            Datenschutz
          </a>
          <span data-id="element-82" data-mp="mptpfyatm0gj">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-plum" data-id="element-83" data-mp="tv4o84h2f862">
            Support
          </a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-plum/40" data-id="element-84" data-mp="yv93jr68lwup">
          © 2026 K-VISUAL MASTERPLAN™ — SIGMA SMART™ — Alle Rechte vorbehalten. Vervielfältigung und
          Weiterverbreitung ohne ausdrückliche Genehmigung verboten.
        </p>
      </div>
    </footer>;
}